import { render } from "./WorkplaceIndex.vue?vue&type=template&id=56d4fa5a&scoped=true"
const script = {}

import "./WorkplaceIndex.vue?vue&type=style&index=0&id=56d4fa5a&scoped=true&lang=css"

import exportComponent from "E:\\work\\HisensePlaza\\code\\front\\httpsPlatform\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d4fa5a"]])

export default __exports__